<script>
  import Time from './Time.svelte';
  import Interval from './Interval.svelte';
  import Record from './Record.svelte';
  import Note from './Note.svelte';

  export let permit;
</script>

<data value={permit.id} class='permit'>
  <header>
    <h2>{permit.title}</h2>
    <Time class='issued'
      utc={permit.issued.utc}
      local={permit.issued.local}
      title={permit.issued.title}
      user={permit.issued.by}
    />
    <Interval valid={permit.valid} />
  </header>
  {#if permit.vehicle}

  <Record item={permit.vehicle} />

  {/if}
  {#if permit.spaces}
  {#each permit.spaces as space}

  <Record item={space} />

  {/each}
  {:else if permit.space}

  <Record item={permit.space} />

  {/if}
  {#if permit.tenant}

  <Record item={permit.tenant} />

  {/if}
  {#if permit.media}

  <Record item={permit.media} />

  {/if}
  {#if permit.notes}
  {#each permit.notes as note}

  <Note item={note} />

  {/each}
  {/if}
</data>
